<template>
  <div class="ec-card">
    <div class="ec-header">
      <h6 class="ec-title">Entradas por Dia</h6>
    </div>
    <div v-if="!entries || entries.length === 0" class="ec-empty">
      <i class="bx bx-bar-chart"></i>
      <span>Nenhum dado disponivel</span>
    </div>
    <div v-else>
      <div class="ec-chart" style="height: 220px;">
        <div class="ec-bars">
          <div
            v-for="entry in normalizedEntries"
            :key="entry.date"
            class="ec-bar-col"
          >
            <div
              class="ec-bar"
              :style="{ height: entry.heightPct + '%' }"
              :title="entry.date + ': ' + entry.count"
            ></div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between mt-2 px-1">
        <small class="ec-date">{{ firstDate }}</small>
        <small class="ec-date">{{ lastDate }}</small>
      </div>
      <div class="ec-summary">
        <div class="ec-sum-item">
          <span class="ec-sum-label">Total</span>
          <span class="ec-sum-val">{{ totalEntries }}</span>
        </div>
        <div class="ec-sum-item">
          <span class="ec-sum-label">Media/Dia</span>
          <span class="ec-sum-val">{{ avgPerDay }}</span>
        </div>
        <div class="ec-sum-item">
          <span class="ec-sum-label">Pico</span>
          <span class="ec-sum-val">{{ peakEntries }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    entries: { type: Array, default: () => [] }
  },
  computed: {
    maxCount () {
      if (!this.entries || this.entries.length === 0) return 0
      return Math.max(...this.entries.map(e => e.count || 0), 1)
    },
    normalizedEntries () {
      return (this.entries || []).map(e => ({
        ...e,
        heightPct: ((e.count || 0) / this.maxCount) * 100
      }))
    },
    firstDate () {
      if (!this.entries || this.entries.length === 0) return ''
      return this.formatDate(this.entries[0].date)
    },
    lastDate () {
      if (!this.entries || this.entries.length === 0) return ''
      return this.formatDate(this.entries[this.entries.length - 1].date)
    },
    totalEntries () {
      return (this.entries || []).reduce((sum, e) => sum + (e.count || 0), 0)
    },
    avgPerDay () {
      if (!this.entries || this.entries.length === 0) return 0
      return Math.round(this.totalEntries / this.entries.length)
    },
    peakEntries () {
      return this.maxCount
    }
  },
  methods: {
    formatDate (dateStr) {
      if (!dateStr) return ''
      const parts = dateStr.split('-')
      if (parts.length === 3) return parts[2] + '/' + parts[1]
      return dateStr
    }
  }
}
</script>

<style scoped>
.ec-card {
  background: #fff;
  border: 1px solid #e2e5eb;
  border-radius: 5px;
  padding: 20px;
}
.ec-header {
  margin-bottom: 16px;
}
.ec-title {
  font-size: 14px;
  font-weight: 700;
  color: #15181e;
  margin: 0;
}
.ec-empty {
  text-align: center;
  padding: 40px 0;
  color: #9aa1b2;
}
.ec-empty i {
  font-size: 28px;
  display: block;
  margin-bottom: 8px;
}
.ec-empty span {
  font-size: 13px;
}
.ec-chart {
  position: relative;
}
.ec-bars {
  display: flex;
  align-items: flex-end;
  gap: 3px;
  height: 100%;
}
.ec-bar-col {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: flex-end;
  height: 100%;
}
.ec-bar {
  width: 100%;
  max-width: 24px;
  margin: 0 auto;
  background: #3b82f6;
  border-radius: 3px 3px 0 0;
  min-height: 0;
  transition: height 0.3s ease;
}
.ec-bar:hover {
  background: #2563eb;
}
.ec-date {
  font-size: 11px;
  color: #9aa1b2;
}
.ec-summary {
  display: flex;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #eceef2;
}
.ec-sum-item {
  flex: 1;
  text-align: center;
  display: flex;
  flex-direction: column;
}
.ec-sum-label {
  font-size: 11px;
  color: #9aa1b2;
  margin-bottom: 2px;
}
.ec-sum-val {
  font-size: 16px;
  font-weight: 700;
  color: #15181e;
}
</style>
